import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const ActiveCampaignWrapperWithChildren = dynamic(() =>
  import('./active-campaign-wrapper').then(
    (m) => m.ActiveCampaignWrapperWithChildren,
  ),
);

Builder.registerComponent(ActiveCampaignWrapperWithChildren, {
  name: 'ActiveCampaignWrapper',
  noWrap: true,
  inputs: [
    {
      name: 'forceShow',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Force Show',
      helperText: 'Show the component even when there is no phone campaign',
    },
  ],
  canHaveChildren: true,
});
